import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { palette } from '@m12s/component-library';

import usePickingSummary from 'lib/hooks/usePickingSummary';
import useRefreshWooCustomFields from 'lib/hooks/useRefreshWooCustomFields';
import { formatMaterialQty } from 'lib/utils/pickingMaterials';

const Notice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin: 0.75rem 1.5rem 0;
  padding: 0.75rem 1rem;
  border: 1px solid ${palette.Orange600};
  border-radius: 0.375rem;
  background: ${palette.White};
  color: ${palette.Grey700};
  font-size: 0.875rem;
  font-weight: 500;
`;

/**
 * Tells the operator when the connector is holding labor on this job because
 * D365 would reject it for short picks (rafResults[ticket].pickShortfall).
 * Renders nothing when no ticket is held. Polls the WOO's custom fields while
 * shown, so the notice appears and clears as the connector writes them.
 */
const PickShortfallNotice = ({ wooId, workOrderId }) => {
  useRefreshWooCustomFields(wooId);
  const { pickShortfalls = [] } = usePickingSummary(wooId);
  if (!pickShortfalls.length) return null;

  const order = workOrderId ? `Order ${workOrderId}` : 'This order';
  return (
    <Notice role="alert">
      {pickShortfalls.map(({ itemNumber, shortQty, unit }) => {
        const qty = `${formatMaterialQty(shortQty)}${unit ? ` ${unit}` : ''}`;
        return (
          <span key={itemNumber}>
            {`${order} is short ${qty} of item ${itemNumber}. Pick ${qty} more to report these parts.`}
          </span>
        );
      })}
    </Notice>
  );
};

PickShortfallNotice.propTypes = {
  wooId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  workOrderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

PickShortfallNotice.defaultProps = {
  wooId: undefined,
  workOrderId: null,
};

export default PickShortfallNotice;
